import React from 'react';
import {Card, Col, Container, Form, Row} from 'react-bootstrap';
import '../layout/main.scss';
import '../home/home.scss';
import './assets.scss';
import troycard from "../../images/TROYGRUN.jpg";


function Assets() {
    return (
        <div className="App">
            <div className="assets">
                <Container>
                    <h3>Assets</h3>
                    <div className="assets_filters">Filters
                        <Form.Select aria-label="SelectCollection">
                            <option>Collection</option>
                            <option value="1">Spells of Genesis</option>
                            <option value="2">Crypto Kitties</option>
                            <option value="3">Blah blah</option>
                        </Form.Select>
                        <Form.Select aria-label="SelectChain">
                            <option>Blockchain</option>
                            <option value="1">Bitcoin/Counterparty</option>
                            <option value="2">Ethereum</option>
                            <option value="3">Klaytn</option>
                            <option value="4">Kusama</option>
                        </Form.Select>
                    </div>
                    <div className="mn-blocks home-assets">
                        <Row xs={1} sm={2} md={3} lg={4} className="g-4">
                            {Array.from({ length: 8 }).map((_, idx) => (
                                <Col>
                                    <Card className="cards cardAsset">
                                        <Card.Img variant="top" src={troycard} />
                                        <Card.Body>
                                            <h5>TROYGRUN</h5>
                                            <h6>Spells of genesis</h6>
                                            <hr/>
                                            <div className="clearfix">
                                                <span style={{float: 'left'}}>Issuance date:</span>
                                                <span style={{float: 'right'}}>06.03.2016</span>
                                            </div>
                                            <div className="clearfix">
                                                <span style={{float: 'left'}}>Nb issued:</span>
                                                <span style={{float: 'right'}}>300</span>
                                            </div>
                                        </Card.Body>
                                    </Card>
                                </Col>
                            ))}
                        </Row>
                    </div>
                </Container>
            </div>
        </div>
    );
}

export default Assets;
